import React from 'react'
import SoompiComponent from 'scripts/components/base/SoompiComponent'
import RenderListings from './listings/RenderListings'
import { toTitleCase, authorInfo } from 'scripts/lib/utils'
import SoompiCommon from './SoompiCommon'
import DropdownList from 'scripts/helpers/DropdownList'
import { extractOrFormInitialData } from 'scripts/helpers/AppHelper'
import Constants from 'scripts/base/Constants'
import { soompi } from 'scripts/api/SoompiApi'

import {connect, actions} from 'scripts/store'

const CommonComponent = SoompiCommon(RenderListings)
const { ListingTypes, ListingPageType } = Constants

class Listings extends SoompiComponent {
  constructor(props) {
    super(props)

    let topicData = extractOrFormInitialData.call(this, 'topicData', null) || props.topicData
    this.state = {
      posts: null,
      title: null,
      name: null,
      hasError: false,
      loading: true,
      btnclicked: false,
      hasMore: true
    }

    this.topicId = null
    this.pageName = null
    this.page = 0
    this.perPage = 15
    this.slug = null
    this.listingInfo = null
    this.listSort = null
    this.sortItems = null

    this.initBaseReceiverData(props)
    if (topicData) {
      const postResponse = topicData.posts
      if (topicData.topic) {
        this.topicId = topicData.topic.id
        this.state = Object.assign(this.state, {
          loading: false,
          name: topicData.topic.name
        }, this.getStateFromPostResponse(postResponse))
      } else if (topicData.author) {
        this.topicId = topicData.author.id
        this.state = Object.assign(this.state, {
          loading: false,
          name: `Articles by ${authorInfo(topicData.author, true)}`
        }, this.getStateFromPostResponse(postResponse))
      } else {
        this.state = Object.assign(this.state, {
          loading: false
        }, this.getStateFromPostResponse(postResponse))
      }
    }
    this.state.hasError = this.isDataAvailable && this.isDataAvailable.hasError
  }

  isLoading = () => {
    return this.state.loading
  }

  setLoading = (value) => {
    this.setState({loading: value})
  }

  getPageType = (name) => {
    switch (name) {
      case ListingTypes.LATEST:
      case ListingTypes.TRENDING:
      case ListingTypes.POPULAR:
        return ListingPageType.SORTED
      case ListingTypes.CATEGORY:
      case ListingTypes.TAG:
      case ListingTypes.FANCLUB:
        return ListingPageType.TAXONOMY
      case ListingTypes.AUTHOR:
        return ListingPageType.AUTHOR
    }
  }

  getListingInfo = (pageName, slug) => {
    let infoPromise = null
    switch (pageName) {
      case ListingTypes.TAG:
        infoPromise = soompi.setLanguage(this.lang).getTagInfo({ slug })
        infoPromise.promise.then((originalResponse) => {
          if (!originalResponse.results || originalResponse.results.length === 0) {
            this.backupInfoPromise = soompi.setLanguage(this.lang).getFCInfo({ slug })
            return this.backupInfoPromise.promise.then((response) => {
              if (response.results && response.results.length > 0) {
                this.props.history.replace(`/fanclub/${slug}`)
              } else {
                return originalResponse
              }
            })
          } else {
            return originalResponse
          }
        })
        break
      case ListingTypes.CATEGORY:
        infoPromise = soompi.setLanguage(this.lang).getCategoryInfo({ slug })
        break
      case ListingTypes.AUTHOR:
        infoPromise = soompi.setLanguage(this.lang).getAuthorInfo({id: slug})
        break
      case ListingTypes.FANCLUB:
        infoPromise = soompi.setLanguage(this.lang).getFCInfo({ slug })
        infoPromise.promise.then((originalResponse) => {
          if (!originalResponse.results || originalResponse.results.length === 0) {
            this.backupInfoPromise = soompi.setLanguage(this.lang).getTagInfo({ slug })
            return this.backupInfoPromise.promise.then((response) => {
              if (response.results && response.results.length > 0) {
                this.props.history.replace(`/tag/${slug}`)
              } else {
                return originalResponse
              }
            })
          } else {
            return originalResponse
          }
        })
        break
    }

    return infoPromise
  }

  loadTopics = (reset) => {
    const {topicId, pageName, perPage, page, listSort} = this
    actions.listingPosts({topicId, pageName, perPage, page, listSort, lang: this.lang})
  }

  authorPosts = () => {
    const {topicId, pageName, perPage, page, listSort} = this
    actions.authorPosts({topicId, pageName, perPage, page, listSort, lang: this.lang})
  }

  loadFeed = (reset) => {
    const {perPage, page, pageName: sort} = this
    actions.listingFeed({sort, perPage, page, lang: this.lang})
  }

  clickLoadMore = (e) => {
    e.preventDefault()
    if (this.isLoading()) { return false }
    this.page += 1
    if (this.getPageType(this.pageName) === ListingPageType.SORTED) {
      this.loadFeed()
    } else if (this.getPageType(this.pageName) === ListingPageType.AUTHOR) {
      this.authorPosts()
    } else {
      this.loadTopics()
    }
    this.setState({btnclicked: 'pressed'})
  }

  useExistingData = (index) => {
    return this.props.listings && this.props.listings[index] && !this.props.clicked
  }

  initData = (props) => {
    window.scrollTo(0, 0)
    if (this.getPageType(this.pageName) === ListingPageType.SORTED) {
      if (this.useExistingData(this.pageName)) {
        this.page = this.props.listings[this.pageName].page
        this.setLoading(false)
        this.setState({posts: this.props.listings[this.pageName].posts})
      } else {
        this.setLoading(true)
        this.loadFeed()
      }
    } else { // taxonomy and author
      this.getListingPromise = this.getListingInfo(this.pageName, this.slug)
      this.getListingPromise.promise.then((response) => {
        if (!response || (this.getPageType(this.pageName) !== ListingPageType.AUTHOR && (!response.results || !response.results.length || response.results.length === 0))) {
          throw new Error('listing not found')
        }
        const result = response.results ? response.results[0] : response
        this.topicId = result.id
        const listKey = this.listSort ? `${this.topicId}-${this.listSort}` : this.topicId
        const name = (this.getPageType(this.pageName) === ListingPageType.AUTHOR) ? this.locale.formatString(this.locale.general.authors, authorInfo(response, true)) : result.name
        // Check if the user went back then just re-use the data we have
        if (this.useExistingData(listKey)) {
          this.page = this.props.listings[listKey].page
          this.setLoading(false)
          this.setState({posts: this.props.listings[listKey].posts, name})
        } else {
          this.setState({name})
          this.setLoading(true)
          if (this.getPageType(this.pageName) === ListingPageType.AUTHOR) {
            this.authorPosts()
          } else {
            this.loadTopics()
          }
        }
      }).catch((e) => {
        console.log(e)
        this.setState({hasError: true, loading: false})
      })
    }
  }

  initBaseReceiverData = (props) => {
    this.page = 1
    const sort = props.match ? props.match.params['sort'] : null
    const slug = props.match ? props.match.params['slug'] : null
    const authorid = props.match ? props.match.params['id'] : null
    const pageName = props.match ? props.match.params['pagename'] : null
    this.pageName = pageName
    this.slug = slug || authorid
    this.listSort = (sort === 'popular') ? 'popularity' : sort
    if (slug) {
      const sortItems = [
        { name: this.locale.sorts.latest, link: `${this.langPrefix}/${pageName}/${slug}`, id: 'sort-none' },
        { name: this.locale.sorts.popular, link: `${this.langPrefix}/${pageName}/${slug}/popular`, id: 'sort-popuplar' },
        { name: this.locale.sorts.trending, link: `${this.langPrefix}/${pageName}/${slug}/trending`, id: 'sort-trending' }
      ]
      this.sortItems = <DropdownList id="listing-sort" dropdown="listing-sort" dropDownList={sortItems} linkText={(sort) ? toTitleCase(sort.toString()) : this.locale.sorts.latest} />
    }
  }

  setComponentProps = (props) => {
    this.initBaseReceiverData(props)
    this.initData(props)
  }

  getStateFromPostResponse = (postResponse, prevPosts = []) => {
    return {
      posts: [...prevPosts, ...postResponse.results],
      hasMore: postResponse.pageInfo ? postResponse.pageInfo.hasNextPage : true,
      btnclicked: false
    }
  }

  componentDidMount() {
    if (!this.isDataAvailable ||
      this.state.hasError ||
      (this.isDataAvailable && !this.isDataAvailable.topicData)) {
      this.setComponentProps(this.props)
    } else {
      const { posts } = this.isDataAvailable.topicData
      const finalData = []
      let index
      if (this.getPageType(this.pageName) === ListingPageType.SORTED) {
        index = this.pageName
      } else {
        index = this.listSort ? `${this.topicId}-${this.listSort}` : this.topicId
      }
      this.page = 1
      finalData[index] = {topicId: index, page: this.page, posts: posts.results, pageInfo: posts.pageInfo}
      actions.initListingPosts(finalData)
    }
  }

  componentWillUnmount() {
    if (this.getTopicPromise) {
      this.getTopicPromise.cancel()
    }
    if (this.getPostsPromise) {
      this.getPostsPromise.cancel()
    }
    if (this.getListingPromise) {
      this.getListingPromise.cancel()
    }
    if (this.backupInfoPromise) {
      this.backupInfoPromise.cancel()
    }
  }

  getPostData = (listing) => {
    return {
      posts: (listing && listing.posts) || null,
      hasMore: (listing ? listing.pageInfo.hasNextPage : true)
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setLoading(true)
      this.setState({hasError: false}) // Make sure to reset error when navigating
      this.setComponentProps(this.props)
    } else if (prevProps.listings !== this.props.listings) {
      this.setLoading(true)
      if (this.getPageType(this.pageName) === ListingPageType.SORTED) {
        this.setState({
          ...this.getPostData(this.props.listings[this.pageName]),
          btnclicked: false,
          loading: false})
      } else {
        const listKey = this.listSort ? `${this.topicId}-${this.listSort}` : this.topicId
        this.setState({
          ...this.getPostData(this.props.listings[listKey]),
          btnclicked: false,
          loading: false})
      }
    }
  }

  render() {
    const { name } = this.state
    const pageTitle = !name ? toTitleCase(`${this.locale.sortpages[this.pageName]}`) : null
    const settings = {pageName: this.pageName, pageTitle: pageTitle, match: this.props.match, clickLoadMore: this.clickLoadMore, sortItems: this.sortItems}
    const finalProps = Object.assign({...this.state}, {...this.props}, {...settings})
    return (
      <CommonComponent {...finalProps} />
    )
  }
}

// componentWillReceiveProps will fire everytime this
// props are updated via the actions
const mapToProps = ({listings, clicked, section}) => {
  return {listings, clicked, section}
}

export default connect(mapToProps)(Listings)



// WEBPACK FOOTER //
// ./assets/js/components/listings.jsx